module.exports = __webpack_public_path__ + "static/media/refer-a-friend.704164f7.svg";